import { HOTELS_BRAND_NAME } from 'config';
import { createSelector } from '@reduxjs/toolkit';
import { getQueryLocation } from 'store/router/routerSelectors';

const FALLBACK_PAGE_TITLE = `Search results | ${HOTELS_BRAND_NAME} Australia`;

export const getPageTitle = createSelector(getQueryLocation, (location) =>
  location ? `Hotels in ${location} | ${HOTELS_BRAND_NAME}` : FALLBACK_PAGE_TITLE,
);
